export const StripeApiKey = 'pk_live_51Rq2C7RpkDk7R5FL0CFD4JWxG1dCeHrxnEtlUHeSU1xXt5btOfdchZcQxJNrLX604D4RYDomy0aAZERNIpQddUqC00diX96yta'; 
